export const consentConfig = {
  version: "1.0",
  last_updated: "2026-07-11",
  ui_labels: {
    title: "Informed Consent",
    meta_app: "Smile2Steps",
    meta_for: "children ages 0–6",
    pill_required: "● REQUIRED",
    pill_optional: "● OPTIONAL",
    progress_ready: "✓ Required step complete. You can now agree.",
    btn_decline: "Cancel",
    btn_agree: "I Agree",
  },
  cards: {
    purpose: {
      lbl: "Our purpose",
      p1: "Smile2Steps helps parents monitor their child’s development through guided play, milestone tracking, and AI-assisted insights.",
      // p2_muted: "Smile2Steps supports parents in observing their child’s growth. It is not a medical device, does not provide diagnoses, and does not replace professional medical care.",
    },
    collect: {
      lbl: "What we collect",
      p1: "We collect only information needed to provide Smile2Steps:",
      bullets: [
        "Parent account information",
        "Child profile information",
        "Play observations",
        "Basic technical information needed to run the app",
        "Developmental information (such as milestones, growth, speech, and screening results)",
      ],
      p2_muted: "We do not sell your child’s information or use it for advertising.",
    },
    benefit: {
      lbl: "Possible benefits",
      p1: "Smile2Steps may help you:",
      bullets: [
        "Understand your child’s development over time.",
        "Get simple daily play activities.",
        "Notice possible developmental concerns earlier.",
        // "Share your child’s developmental record with a healthcare provider or child development professional.",
      ],
    },
    access: {
      lbl: "Who can access my child’s information?",
      p1: "Your child’s information may be accessed by:",
      bullets: [
        "You, as the parent or legal guardian.",
        "Smile2Steps, to provide app features and support.",
        "Trusted service providers that help operate Smile2Steps under privacy agreements.",
      ],
      note: "Healthcare providers or other professionals can access your child’s information only when you choose to share it.",
    },
    datause: {
      lbl: "How we use your information",
      p1: "Smile2Steps uses your child’s information to:",
      bullets: [
        "Provide personalized play activities.",
        "Create developmental insights and progress summaries.",
        "Support Lisha chat features.",
        "Improve your app experience.",
      ],
      p2_muted: "Some Smile2Steps features use trusted AI providers. These providers process information only to provide Smile2Steps features and cannot use it for their own products or purposes.",
    },
    optcard: {
      lbl: "Optional features and choices",
      p1: "You may choose whether to enable the following features.",
      grp: "Share developmental record",
      choices: [
        {
          id: "opt_provider_share",
          title: "I allow Smile2Steps to share my child’s developmental record with a healthcare provider or professional I select.",
          desc: "You’ll pick the specific provider later, in the app, and share only what you select. You can stop sharing anytime.",
        },
        {
          id: "opt_share_health_record",
          title: "I allow secure analysis of non-identifiable growth and milestones to support health record pattern analysis.",
          desc: "Assists pediatric specialists in finding developmental similarities across anonymized trends to better support families.",
        },
      ],
    },
    biocard: {
      lbl: "Voice & video features",
      p1: "Voice and video features are optional. If enabled:",
      bullets: [
        "You may upload short voice or video clips of your child.",
        "Smile2Steps analyzes them for speech, movement, and developmental insights.",
        "Uploaded clips are deleted after analysis.",
        "We store only the developmental results needed to track progress.",
      ],
      p2: "Voice and video clips are processed only by Smile2Steps and are not shared with outside AI providers.",
      grp1: "Additional Charts for your child",
      choices_features: [
        {
          id: "opt_bio_audio_feature",
          tag: "BIOMETRIC INPUT",
          title: "I agree to use voice recordings to support speech development tracking.",
          desc: "Clips are analyzed by Smile2Steps and deleted after analysis; only the developmental results are stored to track your child’s speech over time.",
        },
        {
          id: "opt_bio_video_feature",
          tag: "BIOMETRIC INPUT",
          title: "I agree to use video recordings to support movement and play development tracking.",
          desc: "Clips are analyzed by Smile2Steps and deleted after analysis; only the developmental results are stored to track your child’s movement and play over time.",
        },
      ],
      grp2: "Help improve Smile2Steps",
      grp2_desc: "You may allow Smile2Steps to use non-identifiable information to improve the app for other families.",
      choices_improvements: [
        {
          id: "opt_train_audio",
          tag: "OPTIONAL",
          title: "I allow Smile2Steps to use non-identifiable information from my child’s voice data.",
        },
        {
          id: "opt_train_video",
          tag: "OPTIONAL",
          title: "I allow Smile2Steps to use non-identifiable information from my child’s video data.",
        },
      ],
      note: "These choices are optional and will not affect my child’s experience. You can change these choices or withdraw permission at any time.",
    },
    risk: {
      lbl: "Possible risks",
      p1: "We use security measures to protect your child’s information. However, no online system is completely secure. Please understand:",
      bullets: [
        "AI suggestions may sometimes be incorrect.",
        "Smile2Steps does not diagnose medical conditions.",
        "Consult a healthcare professional if you have concerns about your child’s development.",
      ],
    },
    rights: {
      lbl: "Your rights",
      p1: "You can:",
      bullets: [
        "View your child’s information.",
        "Update information.",
        "Withdraw consent at any time.",
        "Request deletion of your child’s information.",
      ],
    },
    consent: {
      lbl: "Parent / Guardian informed consent",
      p1: "By checking the box below, I confirm that:",
      bullets: [
        "I am the parent or legal guardian of this child.",
        "I understand what information Smile2Steps collects and how it is used.",
        "I consent to the collection and use of my child’s information.",
        "I understand Smile2Steps uses AI to provide personalized guidance and insights.",
        "I understand Smile2Steps does not replace medical advice or diagnosis.",
        "I understand optional features require separate permission.",
        "I know I can withdraw my consent at any time.",
      ],
      legal_links: {
        prefix: "I have read the ",
        privacy: "Privacy Policy",
        mid: " and ",
        terms: "Terms of Service",
        suffix: ".",
      },
      checkboxLabel: "I provide my informed consent for my child to use Smile2Steps.",
    },
  },
  optional_consents: {
      opt_provider_share: "opt_provider_share",
      opt_share_health_record: "opt_share_health_record",
      opt_bio_audio_feature: "opt_bio_audio_feature",
      opt_bio_video_feature: "opt_bio_video_feature",
      opt_train_audio: "opt_train_audio",
      opt_train_video: "opt_train_video",
  },
};